import React from 'react';

export interface SidebarNavProps {
  readonly showAiCapabilityPage?: string;
  readonly onClickSidebarHome?: () => void;
  readonly onClickSidebarCreate?: () => void;
  readonly onClickSidebarSearch?: () => void;
  readonly onClickSidebarDiscover?: () => void;
  readonly onClickSidebarDify?: () => void;
  readonly onClickSidebarHistory?: () => void;
  readonly activeTab?: 'home' | 'create' | 'search' | 'discover' | 'dify' | 'history';
}

export const SidebarNav: React.FC<SidebarNavProps> = ({
  showAiCapabilityPage,
  onClickSidebarHome,
  onClickSidebarCreate,
  onClickSidebarSearch,
  onClickSidebarDiscover,
  onClickSidebarDify,
  onClickSidebarHistory,
  activeTab
}) => {
  const homeBtnClass: string = `side-btn${activeTab === 'home' || !activeTab ? ' active' : ''}`;
  const createBtnClass: string = `side-btn${activeTab === 'create' || !activeTab ? ' active' : ''}`;
  const searchBtnClass: string = `side-btn${activeTab === 'search' ? ' active' : ''}`;
  const discoverBtnClass: string = `side-btn${activeTab === 'discover' ? ' active' : ''}`;
  const difyBtnClass: string = `side-btn${activeTab === 'dify' ? ' active' : ''}`;
  const historyBtnClass: string = `side-btn${activeTab === 'history' ? ' active' : ''}`;

  return (
    <nav className="sidebar">
      {/* <button className={homeBtnClass} onClick={onClickSidebarHome} type="button">
        <i className="fas fa-leaf" />
      </button> */}
      <button className={createBtnClass} onClick={onClickSidebarCreate} type="button">
        <i className="fa-solid fa-plus" />
      </button>
      {/* <button className={searchBtnClass} onClick={onClickSidebarSearch} type="button">
        <i className="fa-solid fa-magnifying-glass" />
      </button>
      <button className={discoverBtnClass} onClick={onClickSidebarDiscover} type="button">
        <i className="fa-regular fa-compass" />
      </button> */}
      {showAiCapabilityPage==='true' && <button className={difyBtnClass} onClick={onClickSidebarDify} type="button">
        <i className="fa-solid fa-shapes" />
      </button>}
      <button className={historyBtnClass} onClick={onClickSidebarHistory} type="button">
        <i className="fa-solid fa-clock-rotate-left" />
      </button>
      {/* <div className="logo-bottom">婷</div> */}
    </nav>
  );
};